import {
  TOGGLE_CART_DRAWER,
  ADD_ITEM_TO_CART,
  REMOVE_ITEM_FROM_CART,
  UPDATE_ITEM_IN_CART,
  CLEAR_CART
} from '../constant/actionType';
import logger from '../util/logger';

export const initialState = {
  isCartOpen: false,
  items: []
};

const customTypeReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case TOGGLE_CART_DRAWER: {
      logger.debug(`${TOGGLE_CART_DRAWER}: ${JSON.stringify(data)}`);

      const isOpen = data.open ? data.open : !state.isCartOpen;

      return { ...state, isCartOpen: isOpen };
    }

    case ADD_ITEM_TO_CART: {
      logger.debug(`${ADD_ITEM_TO_CART}: ${JSON.stringify(data)}`);

      return { ...state, items: [...state.items, data] };
    }

    case REMOVE_ITEM_FROM_CART: {
      logger.debug(`${REMOVE_ITEM_FROM_CART}: ${JSON.stringify(data)}`);

      const { title: domainTitle } = data;
      const filtered = state.items.filter(({ title }) => title !== domainTitle);

      return { ...state, items: filtered };
    }

    case UPDATE_ITEM_IN_CART: {
      logger.debug(`${UPDATE_ITEM_IN_CART}: ${JSON.stringify(data)}`);

      const { title: domainTitle, body } = data;

      const filtered = state.items.filter(({ title }) => title !== domainTitle);

      return { ...state, items: [...filtered, body] };
    }

    case CLEAR_CART: {
      logger.debug(`${CLEAR_CART}: ${JSON.stringify(data)}`);

      return { ...state, items: [] };
    }

    default:
      return state;
  }
};

export default customTypeReducer;
